import { DateTime } from 'luxon'
export default value => {
  return DateTime.fromISO(value).toFormat('DDDD')
}
